export const microTask = (fn: () => void) => Promise.resolve().then(() => fn());
export const macroTask = (fn: () => void, time = 0) => setTimeout(() => fn(), time);
